import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';
import es from './locales/es.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

const STORAGE_KEY = 'omniflow_language';
const savedLanguage = localStorage.getItem(STORAGE_KEY);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: savedLanguage || 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
  });

// El backend responde los errores en el idioma elegido en la app.
const setApiLanguage = (lng) => {
  axios.defaults.headers.common['Accept-Language'] = (lng || 'es').slice(0, 2);
};
setApiLanguage(i18n.language);
i18n.on('languageChanged', setApiLanguage);

export default i18n;